import { render, staticRenderFns } from "./dataprocess.vue?vue&type=template&id=a308bd9a&scoped=true&"
import script from "./dataprocess.vue?vue&type=script&lang=ts&"
export * from "./dataprocess.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a308bd9a",
  null
  
)

export default component.exports